import { type SearchResultContentCityBanner } from '@clients/ContentApi';

export default class CityBanner {
    constructor(data: SearchResultContentCityBanner) {
        this.persianName = data.CityTitle;
        this.backgroundImage = data.BackgroundImage.url;
        this.cityNotation = data.CityNotation.url;
    }

    persianName: string;
    backgroundImage: string;
    cityNotation: string;
}
